import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

interface ResultRowProps {
  coverUrl?: string;
  title: string;
  subtitle: string;
  onClick: () => void;
  rightSlot?: ReactNode;
}

export function ResultRow({
  coverUrl,
  title,
  subtitle,
  onClick,
  rightSlot,
}: ResultRowProps) {
  return (
    <Box>
      <Flex
        align="center"
        gap="24px"
        py="4px"
        cursor="pointer"
        transition="background 0.15s ease"
        _hover={{ bg: "transparent.white.10" }}
        onClick={onClick}
        borderRadius="4px"
      >
        {coverUrl && (
          <Image
            src={coverUrl}
            alt={title}
            w="58px"
            h="89px"
            objectFit="cover"
            borderRadius="4px"
            border="0.5px solid"
            borderColor="transparent.white.20"
            flexShrink={0}
          />
        )}
        <Flex direction="column" minW={0} flex={1} justify="center">
          <Text
            fontSize="16px"
            color="white"
            fontWeight="400"
            fontFamily="Roboto"
            lineHeight="21px"
            noOfLines={1}
          >
            {title}
          </Text>
          <Text
            fontSize="14px"
            color="reader.neutral.400"
            fontFamily="Roboto"
            lineHeight="18px"
            noOfLines={1}
            mt="4px"
          >
            {subtitle}
          </Text>
        </Flex>
        {rightSlot && <Box flexShrink={0}>{rightSlot}</Box>}
      </Flex>
      <Box
        h="1px"
        bg="transparent.white.10"
        ml={coverUrl ? "82px" : "0"}
      />
    </Box>
  );
}
